import axiosLib from 'axios'

import { getRuntimeEnv } from '../runtimeEnv'

const BASE_URL = getRuntimeEnv('REACT_APP_API_URL', 'http://localhost:3000')

const axios = axiosLib.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

export default axios
